const AGENT_STATUS_DEFS = {
  AVAILABLE: { label: 'Disponible', color: '#2E7D32' },
  BUSY: { label: 'En llamada', color: '#FB8C00' },
  INCALL: { label: 'En llamada', color: '#D32F2F' },
  ACW: { label: 'ACW', color: '#6A1B9A' },
  PAUSE: { label: 'En pausa', color: '#1E88E5' },
  BREAK: { label: 'Break', color: '#00ACC1' },
  BATHROOM: { label: 'Ba\u00f1o', color: '#00897B' },
  LUNCH: { label: 'Almuerzo', color: '#F4511E' },
  REST: { label: 'Descanso', color: '#546E7A' },
  TRAINING: { label: 'Capacitaci\u00f3n', color: '#3949AB' },
  ABSENT: { label: 'Ausente', color: '#8D6E63' },
  NOTREADY: { label: 'No disponible', color: '#6D4C41' },
  PRECALL: { label: 'Preview', color: '#FDD835' },
  NO_NETWORK: { label: 'Sin red', color: '#C62828' },
  OFFLINE: { label: 'Desconectado', color: '#757575' }
};

const AGENT_STATUS_ORDER = [
  'AVAILABLE',
  'BUSY',
  'INCALL',
  'ACW',
  'PAUSE',
  'BREAK',
  'BATHROOM',
  'LUNCH',
  'REST',
  'TRAINING',
  'ABSENT',
  'NOTREADY',
  'PRECALL',
  'NO_NETWORK',
  'OFFLINE'
];

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const hexToRgb = (hex) => {
  const normalized = hex.replace('#', '');
  if (normalized.length !== 6) return { r: 0, g: 0, b: 0 };
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return { r, g, b };
};

const rgbToHex = (r, g, b) => {
  const toHex = (channel) => clamp(Math.round(channel), 0, 255).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const mixWithWhite = (hex, amount = 0.2) => {
  const { r, g, b } = hexToRgb(hex);
  const mix = (channel) => channel + (255 - channel) * amount;
  return rgbToHex(mix(r), mix(g), mix(b));
};

const getRelativeLuminance = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  const normalize = (channel) => {
    const value = channel / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * normalize(r) + 0.7152 * normalize(g) + 0.0722 * normalize(b);
};

const getAgentStatusLabel = (status) => AGENT_STATUS_DEFS[status]?.label || status || '';
const getAgentStatusColor = (status) => AGENT_STATUS_DEFS[status]?.color || '#9E9E9E';
const getAgentStatusGradient = (status) => {
  const base = getAgentStatusColor(status);
  const highlight = mixWithWhite(base, 0.3);
  return `linear-gradient(135deg, ${base} 0%, ${highlight} 100%)`;
};
const getAgentStatusNeonColor = (status) => mixWithWhite(getAgentStatusColor(status), 0.4);
const getAgentStatusTextColor = (status) => (getRelativeLuminance(getAgentStatusColor(status)) > 0.6 ? '#000000' : '#FFFFFF');

export {
  AGENT_STATUS_DEFS,
  AGENT_STATUS_ORDER,
  getAgentStatusLabel,
  getAgentStatusColor,
  getAgentStatusGradient,
  getAgentStatusNeonColor,
  getAgentStatusTextColor
};
